<template>
	<v-container fluid>
		<v-row no-gutters>
			<v-col cols="12" sm="12" md="4" lg="4" xl="4">
				<v-toolbar-title class="ml-2 mt-2">Tamanho categoria x Farmácia</v-toolbar-title>
			</v-col>
			<v-col cols="12" sm="12" md="8" lg="8" xl="8" align="end">
				<v-btn class="ml-2 my-1" color="primary" @click="exportar()">
					<v-icon left>mdi-microsoft-excel</v-icon> Exportar
				</v-btn>

				<v-btn
					class="ml-2 my-1"
					color="primary"
					@click="abrirImportar()"
				>
					<v-icon left>mdi-upload</v-icon> Importar
				</v-btn>

				<v-btn
					class="ml-2 my-1"
					color="error"
					:disabled="itensSelecionados.length === 0"
					@click="abrirConfirmarDelecao()"
				>
					<v-icon left>mdi-delete</v-icon> Deletar Tamanhos
				</v-btn>
			</v-col>
		</v-row>
		<v-card class="mt-2 py-4 px-2" elevation="1">
			<v-row no-gutters class="mb-2">
				<v-col cols="12" sm="12" md="4" lg="4" xl="4">
					<v-text-field
						v-model="busca"
						append-icon="mdi-magnify"
						label="Pesquisar"
						dense
						outlined
						hide-details
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="12" md="3" lg="3" xl="3"> </v-col>
			</v-row>
			<v-data-table
				:headers="headers"
				:items="dados"
				:server-items-length="total"
				:items-per-page="5"
				:footer-props="{
					'items-per-page-options': [5, 10, 15, 25, 50, 100],
				}"
				:options.sync="pagination"
				multi-sort
				class="elevation-0"
				show-select
				v-model="itensSelecionados"
				item-key="id_categoria_tamanho"
			>
				<template v-slot:[`item.acoes`]="{ item }">
					  <v-menu offset-y min-width="180" content-class=" tamanho-menu">
						<template v-slot:activator="{ on, attrs }">
							 <v-btn 
									dark 
									color="#f2f2f2" 
									v-bind="attrs" 
									v-on="on" 
									small 
									class="px-1"
									style="min-width: unset"
								>
									<v-icon color="#CCC">mdi-menu</v-icon>
                </v-btn>
						</template>
						<v-card>
							<v-list dense nav>
								<v-list-item @click="abrirEditarItem(item)">
									<v-list-item-icon>
										<v-icon color="primary">mdi-pencil</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Editar</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item @click="deletarItem(item)">
									<v-list-item-icon>
										<v-icon color="error">mdi-delete</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Deletar</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-card>

					</v-menu>
				</template>
				<template v-slot:[`item.botao`]="{ item }">
					<v-icon
						v-if="item.mes >= mesProximo"
						small
						class="mr-2"
						color="primary"
						@click="abrirEditar(item)"
						title="Editar"
					>
						mdi-pencil
					</v-icon>
				</template>
			</v-data-table>
		</v-card>

		<v-dialog v-model="dialogo" width="600">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Editar
				</v-card-title>
				<v-card-text class="mt-4">
					<v-form v-model="validaForm">
						<v-row no-gutters class="mt-4">
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="ID Espaço"
									v-model="custo.id_espaco"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Código Espaço"
									v-model="custo.codigo_espaco"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Espaço"
									v-model="custo.espaco"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="ID Cluster"
									v-model="custo.id_cluster"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Código Cluster"
									v-model="custo.codigo_cluster"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="12"
								lg="12"
								xl="12"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Cluster"
									v-model="custo.cluster"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Mês"
									v-model="custo.mes_nome"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<vuetify-money
									outlined
									dense
									label="Custo Unitário"
									v-model="custo.custo_unitario"
									:options="options"
									clearable="clearable"
								></vuetify-money>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<vuetify-money
									outlined
									dense
									label="Custo Especial"
									v-model="custo.custo_especial"
									:options="options"
									clearable="clearable"
								></vuetify-money>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogo = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
					<v-btn
						color="primary"
						class="pr-4"
						:disabled="!validaForm"
						@click="editar()"
					>
						<v-icon left>mdi-content-save</v-icon> Salvar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoEditarItem" width="800">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Editar Tamanho
				</v-card-title>
				<v-card-text class="mt-4">
					<v-form v-model="validaFormEdicao">
						<v-row no-gutters class="mt-4">
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="ID JAVA"
									v-model="itemEdicao.cd_filial"
									:rules="[v => !!v || 'ID JAVA é obrigatório']"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									disabled
									label="Filial"
									v-model="itemEdicao.nm_fantasia"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Cluster"
									v-model="itemEdicao.ds_filial_cluster"
									disabled
									:rules="[v => !!v || 'Cluster é obrigatório']"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Categoria"
									v-model="itemEdicao.ds_categoria_exposicao"
									:rules="[v => !!v || 'Categoria é obrigatória']"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Tamanho"
									v-model="itemEdicao.ds_mix_tamanho_categ_exposicao"
									:rules="[v => !!v || 'Tamanho é obrigatório']"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-select
									outlined
									dense
									label="Bandeira"
									v-model="itemEdicao.id_bandeira"
									:items="bandeiraOptions"
									item-text="text"
									item-value="value"
									:rules="[v => !!v || 'Bandeira é obrigatória']"
								></v-select>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Qtd Gondolas"
									v-model="itemEdicao.qt_gondolas"
									type="number"
									:rules="[v => v >= 0 || 'Quantidade deve ser maior ou igual a 0']"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="Faturando"
									v-model="itemEdicao.faturando"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="CD Abastecimento"
									v-model="itemEdicao.cd_abastecimento"
								></v-text-field>
							</v-col>
							<v-col
								cols="12"
								sm="12"
								md="6"
								lg="6"
								xl="6"
								class="px-2"
							>
								<v-text-field
									outlined
									dense
									label="DS Abastecimento"
									v-model="itemEdicao.ds_abastecimento"
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="grey"
						text
						@click="dialogoEditarItem = false"
					> 
						<v-icon left>mdi-close</v-icon> Cancelar
					</v-btn>
					<v-btn
						color="primary"
						:disabled="!validaFormEdicao"
						@click="editarItem()"
					>
						<v-icon left>mdi-content-save</v-icon> Salvar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoConfirmarEdicaoCritica" max-width="500">
			<v-card>
				<v-card-title class="subtitle-1 warning white--text">
					<v-icon left color="white">mdi-alert</v-icon>
					Alterações com Impacto nos Planogramas
				</v-card-title>
				<v-card-text class="mt-4">
					<p>Os seguintes campos chave foram modificados:</p>
					<ul class="ml-4">
						<li><strong>ID JAVA</strong></li>
						<li><strong>Categoria</strong></li>
						<li><strong>Tamanho</strong></li>
						<li><strong>Bandeira</strong></li>
					</ul>
					<p class="mt-3">
						<strong>Atenção:</strong> Ao confirmar essas alterações, 
						<span class="error--text">todos os planogramas associados à combinação 
						<strong>{{ itemEdicaoOriginal.ds_categoria_exposicao }}_{{ itemEdicaoOriginal.bandeira }}_{{ itemEdicaoOriginal.ds_filial_cluster }}_{{ itemEdicaoOriginal.ds_mix_tamanho_categ_exposicao }}</strong> 
						serão permanentemente excluídos</span>.
					</p>
					<p class="mt-2">Deseja realmente continuar?</p>
				</v-card-text>

				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="grey"
						text
						@click="dialogoConfirmarEdicaoCritica = false"
					>
						<v-icon left>mdi-close</v-icon> Cancelar
					</v-btn>
					<v-btn
						color="warning"
						@click="confirmarEdicaoCritica()"
					>
						<v-icon left>mdi-check</v-icon> Confirmar Alteração
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoImportar" width="90%">
			<v-card>
				<v-card-title class="subtitle-1 primary white--text">
					Importar CSV
				</v-card-title>
				<v-card-text>
					<v-alert
						class="ma-1"
						text
						type="info"
						border="left"
						style="font-size: 12px;"
					>
						<ul>
							<li> A base utilizada para importação deve ser parecida com base exportada.</li>
							<li> As colunas 
								<strong>CD_FILIAL</strong> (Código filial), 
								<strong>DS_CATEGORIA_EXPOSICAO</strong> (Descrição Categoria),
								<strong>DS_MIX_CATEG_EXPOSICAO</strong> (Descrição Mix Categoria),
								<strong>BANDEIRA</strong> (BANDEIRA),
								são obrigatórias 
								(<strong>
									e os nomes devem ser identicos aos da base
									exportada
								</strong>)
									, as demais colunas podem ser excluidas.
							</li>
						</ul>
					</v-alert>
					<v-row>
						<v-col cols="8" class="px-2">
							<v-form ref="form" v-model="isCsv">
								<v-file-input
									label="Arquivo CSV"
									outlined
									dense
									v-model="arquivoCSV"
									:rules="regra.csv"
									accept=".csv"
								></v-file-input>
							</v-form>
						</v-col>
						<v-col cols="4" class="px-2">
							<v-btn
								color="primary"
								:disabled="
									!isCsv || mes_importacao < mesProximo
								"
								@click="importar()"
							>
								<v-icon left>mdi-upload</v-icon>
								Importar Arquivo
							</v-btn>
						</v-col>
					</v-row>
					<v-expand-transition>
						<div v-show="erro">
							<v-row no-gutters class="mb-0">
								<v-col cols="6">
									<download-csv
										:data="erros"
										:labels="errosLabels"
										name="erros.csv"
										delimiter=";"
									>
										<v-btn color="primary">
											<v-icon left
												>mdi-microsoft-excel</v-icon
											>
											Exportar Erros
										</v-btn>
									</download-csv>
								</v-col>
							</v-row>
							<v-data-table
								:headers="headerErros"
								:items="erros"
								:items-per-page="5"
								:options.sync="paginationErros"
								class="elevation-0 data-table-2"
							></v-data-table>
						</div>
					</v-expand-transition>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary"
						class="pr-4"
						@click="dialogoImportar = false"
					>
						<v-icon left>mdi-close</v-icon> Fechar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogoConfirmarDelecao" max-width="400">
			<v-card>
				<v-card-title class="subtitle-1 error white--text">
					Confirmar Exclusão
				</v-card-title>
				<v-card-text class="mt-4">
					<p v-if="itemParaDeletar">Tem certeza de que deseja deletar o item selecionado?</p>
					<p v-else>Tem certeza de que deseja deletar os <strong>{{ itensSelecionados.length }}</strong> itens selecionados?</p>
					<p class="text--secondary">
						Se esse tamanho tiver um planograma associado, o planograma será removido.
					</p>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="grey"
						text
						@click="dialogoConfirmarDelecao = false"
					>
						Cancelar
					</v-btn>
					<v-btn
						color="error"
						@click="deletarTamanhos()"
					>
						<v-icon left>mdi-delete</v-icon> Deletar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-overlay :value="carregando" :z-index="300">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>

		<v-snackbar
			v-model="alerta"
			:color="alertaColor"
			:timeout="alertaTimeout"
			top
			style="z-index: 400"
		>
			<v-alert :type="alertaColor">
				{{ alertaTexto }}
			</v-alert>
			<v-btn dark text class="float-right" @click="alerta = false">
				Fechar
			</v-btn>
		</v-snackbar>
	</v-container>
</template>

<script>
const TYPES_FILES = ['.csv', '.xls', '.xlsx'];

export default {
	data() {
		return {
			headers: [
				{ text: "Ações", value: "acoes", align: "center", sortable: false },
				{ text: "ID JAVA", value: "cd_filial", align: "center" },
				{ text: "Filial", value: "nm_fantasia", align: "center" },
				{ text: "Cluster", value: "ds_filial_cluster", align: "center" },
				{ text: "Categoria", value: "ds_categoria_exposicao", align: "center" },
				{ text: "Tamanho", value: "ds_mix_tamanho_categ_exposicao", align: "center" },
				{ text: "Bandeira", value: "bandeira", align: "center" },
				{ text: "Qtd Gondolas", value: "qt_gondolas", align: "center" },
				{ text: "Faturando", value: "faturando", align: "center" },
				{ text: "Tipo loja", value: "tipo_loja", align: "center" },
				{ text: "CD Abastecimento", value: "cd_abastecimento", align: "center" },
				{ text: "DS Abastecimento", value: "ds_abastecimento", align: "center" }
			],
			dados: [],
			itensSelecionados: [],
			itemParaDeletar: null,
			itemEdicao: {},
			itemEdicaoOriginal: {},
			mes: null,
			mes_importacao: null,
			custo: {
				id_espaco: null,
				codigo_espaco: null,
				espaco: null,
				id_cluster: null,
				codigo_cluster: null,
				cluster: null,
				mes_nome: null,
				custo_unitario: null,
				custo_especial: null,
			},
			pagination: {},
			paginationErros: {},
			total: null,
			carregando: false,
			busca: null,
			dialogo: false,
			dialogoImportar: false,
			dialogoConfirmarDelecao: false,
			dialogoEditarItem: false,
			dialogoConfirmarEdicaoCritica: false,
			validaForm: false,
			validaFormEdicao: false,
			alerta: false,
			alertaTexto: "",
			alertaColor: "error",
			alertaTimeout: 3000,
			arquivoCSV: null,
			lista: {
				macrofornecedor: [],
			},
			regra: {
				csv: [
					(v) => !!v || "Selecione um arquivo.",
					(v) =>
						(!!v && TYPES_FILES.some(ext => v.name.toLowerCase().endsWith(ext))) ||
						`O arquivo deve ser do tipo ${TYPES_FILES.join(", ")}`,
				]
			},
			isCsv: false,
			headerErros: [
				{ text: "Descrição do Erro", value: "msg", align: "left" },
			],
			erros: [],
			errosLabels: { msg: "Descrição do Erro" },
			erro: false,
			options: {
				locale: "pt-BR",
				prefix: "R$",
				suffix: "",
				length: 11,
				precision: 2,
			},
			bandeiraOptions: [
				{ text: 'RAIA', value: 1 },
				{ text: 'DROGASIL', value: 2 }
			],
		};
	},
	watch: {
		pagination: {
			handler() {
				this.filtrar();
			},
			deep: true,
		},
		busca(v) {
			setTimeout(() => {
				if (v == this.busca) {
					this.filtrar();
				}
			}, 1500);
		},
	},
	async created() {
		this.mes = this.mesProximo;
		this.mes_importacao = this.mesProximo;
		this.carregarListaTotal()
	},
	computed: {
		mesProximo() {
			return this.$moment()
				.add(1, "months")
				.format("YYYY-MM");
		},
	},
	methods: {
		async filtrar() {

			this.carregando = true;

			var data = { mes: this.mes + "-01" };

			data.pagination = this.pagination;
			data.busca = this.busca;

			var response = await this.$http().post("/categoriaTamanho/lista", {
				data: data,
			});
			this.carregarListaTotal(data);
			this.dados = response.data;

			if (this.total == 0 && this.pagination.page > 1) {
				this.pagination.page = 1;
				this.filtrar();
			}

			this.carregando = false;
		},
		async exportar(rotaApi = "exportar") {

			this.carregando = true;

			var data = { mes: this.mes + "-01" };

			var response = await this.$http().post("/categoriaTamanho/" + rotaApi, {
				data: data,
			});

			window.location = this.$http("baseURL") + response.data.url;

			this.carregando = false;
		},
		abrirEditar(item) {
			this.custo = { ...item };

			this.dialogo = true;
		},
		async editar() {
			this.carregando = true;

			var data = this.custo;

			var response = await this.$http().post("/custo/editar", {
				data: data,
			});

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();

				this.dialogo = false;
			} else {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = -1;
				this.alertaTexto = response.data.msg;
			}
		},
		abrirImportar() {

			this.arquivoCSV = null;
			this.erro = false;

			this.mes_importacao =
				this.mes < this.mesProximo ? this.mesProximo : this.mes;
			this.dialogoImportar = true;
		},
		async importar() {
			this.carregando = true;


			var formData = new FormData();

			formData.append("files", this.arquivoCSV);

			this.arquivoCSV = null;

			var response = await this.$http().post("/categoriaTamanho/importar", formData);

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();
				this.dialogoImportar = false;
			} else {
				this.filtrar();
				this.erros = response.data.erros;
				this.pagination.page = 1;
				this.erro = true;
			}
		},
		async carregarListaTotal(data) {
			this.carregando = true;
			const response = await this.$http().post("/categoriaTamanho/listaTotal", data);

			this.total = response.data[0].count.length > 0 ? response.data[0].count: 0;
			this.carregando = false;
		},
		abrirEditarItem(item) {
			this.itemEdicao = { ...item };
			
			if (item.bandeira === 'RAIA') {
				this.itemEdicao.id_bandeira = 1;
			} else if (item.bandeira === 'DROGASIL') {
				this.itemEdicao.id_bandeira = 2;
			}
			
			this.itemEdicaoOriginal = { ...item };
			this.dialogoEditarItem = true;
		},
		verificarCamposCriticos() {
			const camposCriticos = ['cd_filial', 'ds_filial_cluster', 'ds_categoria_exposicao', 'ds_mix_tamanho_categ_exposicao', 'id_bandeira'];
			
			return camposCriticos.some(campo => 
				this.itemEdicao[campo] !== this.itemEdicaoOriginal[campo]
			);
		},
		async editarItem() {
			if (this.verificarCamposCriticos()) {
				this.dialogoConfirmarEdicaoCritica = true;
				return;
			}
			this.salvarEdicaoItem();
		},
		async confirmarEdicaoCritica() {
			this.dialogoConfirmarEdicaoCritica = false;
			this.salvarEdicaoItem();
		},
		async salvarEdicaoItem() {
			this.carregando = true;

			var data = {
				...this.itemEdicao,
				id: this.itemEdicao.id_categoria_tamanho,
				id_bandeira: this.itemEdicao.id_bandeira
			};
			
			delete data.bandeira;
			var response = await this.$http().post("/categoriaTamanho/editar", {
				data: data,
			});

			this.carregando = false;
			if (response.data.sucesso) {
				this.filtrar();
				this.dialogoEditarItem = false;
				
				this.alerta = true;
				this.alertaColor = "success";
				this.alertaTimeout = 3000;
				this.alertaTexto = "Item editado com sucesso!";
			} else {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = -1;
				this.alertaTexto = response.data.mensagem || "Erro ao editar o item.";
			}
		},
		deletarItem(item) {
			this.itemParaDeletar = item;
			this.dialogoConfirmarDelecao = true;
		},
		abrirConfirmarDelecao() {
			this.itemParaDeletar = null;
			this.dialogoConfirmarDelecao = true;
		},
		async deletarTamanhos() {
			this.carregando = true;

			var data = {};

			if (this.itemParaDeletar) {
				data.ids = [this.itemParaDeletar.id_categoria_tamanho];
			} else {
				data.ids = this.itensSelecionados.map(item => item.id_categoria_tamanho);
			}

			var response = await this.$http().post("/categoriaTamanho/deletar", {
				data: data,
			});

			this.carregando = false;

			if (response.data.sucesso) {
				this.filtrar();
				
				if (this.itemParaDeletar) {
					this.itemParaDeletar = null;
				} else {
					this.itensSelecionados = [];
				}
				
				this.dialogoConfirmarDelecao = false;
				
				this.alerta = true;
				this.alertaColor = "success";
				this.alertaTimeout = 3000;
				this.alertaTexto = "Itens deletados com sucesso!";
			} else {
				this.alerta = true;
				this.alertaColor = "error";
				this.alertaTimeout = -1;
				this.alertaTexto = response.data.msg || "Erro ao deletar os itens selecionados.";
			}
		}
	},
};
</script>
